import React from 'react';
import classes from './index.module.scss';

const EntityButton = ({ label, value, chooseEntityHandler, styles}) => {
  return (
    <div 
      className={`${classes.EntityButton} ${styles ? classes.Active : ""}`} 
      onClick={() => chooseEntityHandler(value)}
    >
      <span>{label}</span>
    </div>
  )
}

export default EntityButton;